import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/crm/churn-risk',
}).lazy(() => import('./churn-risk.lazy').then((d) => d.Route))
